import $ from 'jquery'
import moment from 'moment'
import datepickerFactory from 'jquery-datepicker'

datepickerFactory($)

export default class Datepicker {

  static init () {

    /*
      Datepicker (nur für Belieferung/consumption_point) ist min. 2 Wochen in der Zukunft, dann jeder Tag. 
      Datepicker (DV/production_point) ist min. 6 Wochen zum 1. eines Monats und von dort an jeweils nur „der 1. eines Monats“. 
     */

    let $toInit = $('.use-datepicker:not(.hasDatepicker):not(.dm)')

    $toInit.datepicker({
      minDate: '+2w',
      dateFormat: 'dd MM yy',
      onSelect: function (event) {
        const selectedDate = moment(event, 'D MMM YYYY', 'de').format('D.M.YYYY')
        localStorage.setItem(this.id, selectedDate)
      },
    })

    $toInit = $('.use-datepicker.dm:not(.hasDatepicker)')

    let dmDate = new Date()
    dmDate.setDate(dmDate.getDate() + 6 * 7)
    //dmDate.setDate(1)
    if (dmDate.getDate() > 1) {
      
      //Round to next Month
      dmDate.setDate(1)
      dmDate.setDate(32)
      dmDate.setDate(1)
    }

    console.log (dmDate.getDay())

    $toInit.datepicker({
      minDate: dmDate,
      dateFormat: 'MM yy',
      changeMonth: true,
      changeYear: true,

      onSelect: function (event) {
        let selectedDate = moment(event, 'MMM YYYY', 'de')
        selectedDate.date(1)
        localStorage.setItem(this.id, selectedDate.format('YYYY-MM-DD'))
      },
    })

    //$('#vol_orders_start_date').datepicker({
      //minDate: '+1m',
      //dateFormat: 'dd MM yy',
      //onSelect: function (event) {
        //const selectedDate = moment(event, 'D MMM YYYY', 'de').format('D.M.YYYY')
        //localStorage.setItem('vol_orders_start_date', selectedDate)
      //},
    //})

    $.datepicker.regional.de = {
      monthNames: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
      monthNamesShort: [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
        'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
      dayNames: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
      dayNamesShort: [ 'Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam' ],
      dayNamesMin: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
      firstDay: 1,
    }

    $.datepicker.setDefaults($.datepicker.regional.de)
  }
}
